import { useState, useEffect } from 'react';

import { getClientGoalCriticalElements } from 'api/generated/client-goal-critical-elements/client-goal-critical-elements';
import type { CriticalElementDto } from 'api/generated/schemas';

export interface UseGoalCriticalElementsResult {
  criticalElements: CriticalElementDto[];
  loading: boolean;
}

const useGoalCriticalElements = (
  goalId: string | number | null | undefined,
  userId: string | null | undefined
): UseGoalCriticalElementsResult => {
  const [criticalElements, setCriticalElements] = useState<
    CriticalElementDto[]
  >([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCriticalElements = async (): Promise<void> => {
      if (!goalId || !userId) {
        setCriticalElements([]);

        return;
      }

      setLoading(true);

      try {
        const list = await getClientGoalCriticalElements(
          userId,
          Number(goalId)
        );

        setCriticalElements(list ?? []);
      } catch (error) {
        console.error(
          `Error fetching critical elements for goal ${goalId}`,
          error
        );
        setCriticalElements([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCriticalElements();
  }, [goalId, userId]);

  return { criticalElements, loading };
};

export default useGoalCriticalElements;
